import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Params, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class NavigationHistoryService {
  private dashboardValue: {
    dateType: string;
    startDate: string;
    endDate: string;
  } = { dateType: '', startDate: '', endDate: '' };
  private calendarValue: {
    viewType: string;
    viewDate: string;
  } = { viewType: '', viewDate: '' };
  private mainTableArchivedValue: boolean = false;
  /** Last query params of /app/job so "back" restores the filtered list or board. */
  private jobListQueryParams: Params = {};
  private singleClientTabValue: { type: string; archived: boolean } = {
    type: '',
    archived: false,
  };
  private singleJobTabValue: { type: string; archived: boolean } = {
    type: '',
    archived: false,
  };

  constructor(
    private location: Location,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  routeToBackPage(previousPageType?: string): void {
    if (previousPageType) {
      switch (previousPageType) {
        case 'CLIENT_TABLE':
          this.router.navigate(['/app/client']);
          break;
        case 'LEAD_TABLE':
          this.router.navigate(['/app/lead']);
          break;
          case 'LEAD_KANBAN':
              this.router.navigate(['/app/lead'], { queryParams: { kanban: false } });
              break;
        case 'JOB_TABLE':
          this.router.navigate(['/app/job'], {
            queryParams: {
              ...this.jobListQueryParams,
              view: null,
              restored: '1',
            },
          });
          break;
        case 'JOB_KANBAN':
          this.router.navigate(['/app/job'], {
            queryParams: {
              ...this.jobListQueryParams,
              view: 'board',
              restored: '1',
            },
          });
          break;
        case 'QUOTATION_TABLE':
          this.router.navigate(['/app/quotation']);
          break;
          case 'QUOTATION_KANBAN':
              this.router.navigate(['/app/quotation'], { queryParams: { kanban: false } });
              break;
        case 'INVOICE_TABLE':
          this.router.navigate(['/app/invoice']);
          break;
        case 'USER_TABLE':
          this.router.navigate(['/app/user']);
          break;
        case 'RECURRING_JOB_UPDATE':
          this.location.historyGo(-2);
          break;
        default:
          this.location.back();
      }
    } else {
      this.location.back();
    }
  }

  removeAllValues() {
    this.removeCalendarValue();
    this.removeDashboardValue();
    this.removeMainTableArchivedValue();
    this.jobListQueryParams = {};
    this.removeSingleClientTabValue();
    this.removeSingleJobTabValue();
  }
  setDashboardValue(
    dateType: string,
    startDate?: string,
    endDate?: string
  ): void {
    this.dashboardValue = {
      dateType,
      startDate: startDate ? startDate : '',
      endDate: endDate ? endDate : '',
    };
  }
  getDashboardValue(): any {
    return this.dashboardValue;
  }
  removeDashboardValue(): void {
    this.dashboardValue = { dateType: '', startDate: '', endDate: '' };
  }
  setCalendarValue(viewType: string, viewDate: string): void {
    this.calendarValue = {
      viewType,
      viewDate,
    };
  }
  getCalendarValue(): any {
    return this.calendarValue;
  }
  removeCalendarValue(): void {
    this.calendarValue = {
      viewType: '',
      viewDate: '',
    };
  }
  setMainTableArchivedValue(value: boolean): void {
    this.mainTableArchivedValue = value;
  }
  getMainTableArchivedValue(): boolean {
    return this.mainTableArchivedValue;
  }
  removeMainTableArchivedValue(): void {
    this.mainTableArchivedValue = false;
  }
  setJobListQueryParams(params: Params): void {
    this.jobListQueryParams = { ...params };
  }

  getJobListQueryParams(): Params {
    return { ...this.jobListQueryParams };
  }

  setSingleClientTabValue(): void {
    if (this.route.snapshot.queryParamMap.get('cli_type')) {
      const type = this.route.snapshot.queryParamMap.get('cli_type');
      const archived = this.route.snapshot.queryParamMap.get('arch');
      if (type && archived) {
        this.singleClientTabValue = {
          type,
          archived: JSON.parse(archived),
        };
      }
    }
  }
  getSingleClientTabValue(): any {
    return this.singleClientTabValue;
  }
  removeSingleClientTabValue(): void {
    this.singleClientTabValue = { type: '', archived: false };
  }
  setSingleJobTabValue(): void {
    if (this.route.snapshot.queryParamMap.get('pre_sli_jb_tb')) {
      const type = this.route.snapshot.queryParamMap.get('pre_sli_jb_tb');
      const archived = this.route.snapshot.queryParamMap.get('arch');
      if (type) {
        this.singleJobTabValue = {
          type,
          archived: archived ? JSON.parse(archived) : false,
        };
      }
    }
  }
  setSingleJobTabValueManually(type: string, archived = false): void {
    this.singleJobTabValue = { type, archived: archived };
  }
  getSingleJobTabValue(): any {
    return this.singleJobTabValue;
  }
  removeSingleJobTabValue(): void {
    this.singleJobTabValue = { type: '', archived: false };
  }
}
